import { FullPageExportSurfaceMissingError } from './types.js';

/**
 * Canonical admin full-page capture root.
 * Prefer `#main [data-admin-export-surface="page"]`, then `#main [data-testid="admin-shell-grid"]`.
 * Never silently no-ops: missing in-`#main` surface throws
 * {@link FullPageExportSurfaceMissingError}. Document-level (orphan) grids are not accepted.
 */
export function resolveFullPageExportSurface(): HTMLElement {
  const main = document.getElementById('main');
  const surface =
    main?.querySelector('[data-admin-export-surface="page"]') ??
    main?.querySelector('[data-testid="admin-shell-grid"]') ??
    null;
  if (!(surface instanceof HTMLElement)) {
    throw new FullPageExportSurfaceMissingError();
  }
  return surface;
}
